<template>
	<div>


		<div class="row">
			<div class="col-xs-12">
				<div class="alert alert-info">
					<h1>Powered by WangEditor.</h1>
					<p>说明：给普通用户填写的内容时，我们使用NbEditor控件，这个编辑器功能较为简单，但是能够满足大多数文字排版功能。</p>
					<p>当我们给管理员使用的时候，用NbUEditor，用NbUEditor功能更为强大！</p>
				</div>
			</div>


		</div>

		<div class="row">
			<div class="col-xs-12">

				<div class="bg-white">
					<NbEditor v-model="content1" height="250px"/>
				</div>

			</div>
			<div class="col-xs-12" style="word-wrap: break-word">
				{{content1}}
			</div>
		</div>


		<div class="row mt20">
			<div class="col-xs-12">

				<div class="bg-white">
					<NbEditor v-model="content2" height="250px"/>
				</div>

			</div>
			<div class="col-xs-12" style="word-wrap: break-word">
				{{content2}}
			</div>
		</div>


	</div>

</template>
<script>

	import NbEditor from "../../../common/widget/NbEditor.vue";


	export default{
		data(){
			return {
				content1: "",
				content2: ""
			}
		},
		watch: {},
		methods: {},
		components: {
			NbEditor
		},
		mounted(){

		}
	}
</script>



// WEBPACK FOOTER //
// NbEditorDemo.vue?00d8e412